/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./StakeView.vue?vue&type=template&id=62a97c7c&scoped=true"
import script from "./StakeView.vue?vue&type=script&lang=js"
export * from "./StakeView.vue?vue&type=script&lang=js"
import style0 from "./StakeView.vue?vue&type=style&index=0&id=62a97c7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a97c7c",
  null
  
)

export default component.exports